import { render, staticRenderFns } from "./optionSettings.vue?vue&type=template&id=0110997c&scoped=true"
import script from "./optionSettings.vue?vue&type=script&lang=js"
export * from "./optionSettings.vue?vue&type=script&lang=js"
import style0 from "./optionSettings.vue?vue&type=style&index=0&id=0110997c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0110997c",
  null
  
)

export default component.exports